<template>
  <div v-if="loading" class="clearfix">
    <b-spinner class="float-right" label="Floated Right" />
  </div>
  <div v-else>
    <b-tabs v-model="activeTab" @input="onTabChange">
      <b-tab>
        <template #title>
          <feather-icon icon="ClockIcon" />
          <span>Atendimentos </span>
        </template>
        <app-collapse type="margin">
          <app-collapse-item title="Atendimentos" :isVisible="true">
            <FormDadosAtendimentoVue />
          </app-collapse-item>
        </app-collapse>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  BRow,
  BCol,
  BSpinner,
  BFormGroup,
  BFormInput,
  BTabs,
  BTab,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import flatPickr from "vue-flatpickr-component";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
// eslint-disable-next-line import/no-cycle
import mixinsGlobal from "@/mixins";
import FormDadosAtendimentoVue from "./FormDadosAtendimento.vue";

import { quillEditor } from "vue-quill-editor";

// Constantes extraídas para melhorar legibilidade
const TYPES_FIELDS = {
  STRING: 0,
  BOOLEAN: 1,
  DECIMAL: 2,
  INTEGER: 3,
  DATA: 4,
  TEXTO: 5,
};

// Tempo de inatividade em milissegundos (3 minutos)
const INACTIVITY_TIMEOUT = 3 * 60 * 1000;

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    BRow,
    BCol,
    BSpinner,
    FormDadosAtendimentoVue,
    BFormGroup,
    BFormInput,
    BTabs,
    BTab,
    flatPickr,
    ButtonsFormVue,
    BFormCheckbox,
    quillEditor,
    BButton,
  },
  mixins: [mixinsGlobal],

  computed: {
    ...mapState("atendimentoModule", {
      atendimento: (state) => state.atendimento,
    }),
  },

  data() {
    return {
      collapseType: "default",

      listaGrupos: [],
      loading: false,
      loadingCampos: false,
      disableForm: true,
      TYPES_FIELDS,
      inactivityTimer: null,
      inactivityTimeout: INACTIVITY_TIMEOUT,
      lastActivity: Date.now(),
      activeTab: 0,
      previousTab: 0,
      editorOptions: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image"],
          ],
        },
        placeholder: "Digite o conteúdo aqui...",
        theme: "snow",
      },
    };
  },

  mounted() {
    this.setupActivityListeners();
  },

  beforeDestroy() {
    this.removeActivityListeners();
    this.clearInactivityTimer();
  },

  methods: {
    receita(procedimento) {
      this.report = {};
      this.report = {
        paciente: this.atendimento.registro.nome,
        html: procedimento.campo_adicional[0].valor,
      };
      this.$store
        .dispatch("reportModule/printReportReceita", this.report)
        .then((response) => {
          if (response.error) {
            this.MensagemError("Falha Impressão", response.error);
            return;
          }
          this.showMessageSuccess("Impressão", response.msg);
        });
    },
    imprimirParecer() {
      this.$bvToast.toast(
        "Gerando parecer. Isso pode levar alguns segundos...",
        {
          title: "Aguarde",
          variant: "info",
          solid: true,
        },
      );

      this.$store
        .dispatch("parecerCardiologicoModule/imprimirRelatorio", {
          atendimento_id: this.atendimento.id,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Parecer_Cardiologico_${this.atendimento.id}.pdf`,
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          console.error("Erro ao gerar PDF de Parecer:", error);
          this.$bvToast.toast("Falha ao gerar o parecer cardiológico.", {
            title: "Erro de Emissão",
            variant: "danger",
            solid: true,
          });
        });
    },
    // Métodos de ciclo de vida e configuração
    setupActivityListeners() {
      const events = [
        "mousemove",
        "mousedown",
        "keypress",
        "touchmove",
        "click",
        "scroll",
      ];
      events.forEach((event) => {
        document.addEventListener(event, this.resetInactivityTimer);
      });
    },

    removeActivityListeners() {
      const events = [
        "mousemove",
        "mousedown",
        "keypress",
        "touchmove",
        "click",
        "scroll",
      ];
      events.forEach((event) => {
        document.removeEventListener(event, this.resetInactivityTimer);
      });
    },

    // Métodos de gerenciamento de inatividade
    startInactivityTimer() {
      this.resetInactivityTimer();
      this.inactivityTimer = setInterval(() => {
        const currentTime = Date.now();
        const timeSinceLastActivity = currentTime - this.lastActivity;

        if (
          timeSinceLastActivity >= this.inactivityTimeout &&
          !this.disableForm
        ) {
          this.autoSave();
        }
      }, 10000); // Verificar a cada 10 segundos
    },

    resetInactivityTimer() {
      this.lastActivity = Date.now();
    },

    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearInterval(this.inactivityTimer);
        this.inactivityTimer = null;
      }
    },

    autoSave() {
      this.salvarCamposAdicionais(true);
    },

    extrairGruposProcedimentos(gruposProcedimento) {
      const grupos = [];

      gruposProcedimento.forEach((grupo) => {
        if (grupo.id !== 0) {
          const grupoFormatado = {
            id: grupo.id,
            grupo: grupo.nome ? grupo.nome : "Padrão",
            procedimentos: this.formatarProcedimentos(grupo.procedimento),
          };
          grupos.push(grupoFormatado);
        }
      });

      return grupos;
    },

    formatarProcedimentos(procedimentos) {
      return procedimentos.map((procedimento) => {
        const procedimentoFormatado = { ...procedimento };
        procedimentoFormatado.campo_adicional =
          procedimento.campo_adicional.map((campo) => {
            return {
              ...campo,
              valor:
                campo.campo_atendimento.length > 0
                  ? campo.campo_atendimento[0]?.valor
                  : null,
            };
          });
        return procedimentoFormatado;
      });
    },

    // Métodos de ações do usuário
    async editar() {
      this.disableForm = false;
      this.aplicarEstiloDisabilitadoEmCampoData();
      this.startInactivityTimer();
    },

    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.aplicarEstiloDisabilitadoEmCampoData();
      this.clearInactivityTimer();
    },
    onTabChange(newTab) {
      // If form is being edited, prevent tab change
      if (!this.disableForm) {
        if (this.activeTab === this.previousTab) {
          return;
        }
        // Show warning toast
        this.$bvToast.toast(
          "Por favor, salve ou cancele as alterações antes de trocar de aba.",
          {
            title: "Atenção",
            variant: "warning",
            solid: true,
            toaster: "b-toaster-top-center",
            noAutoHide: false,
          },
        );
        // Revert to previous tab
        this.$nextTick(() => {
          this.activeTab = this.previousTab;
        });
        return;
      }

      // Save current tab as previous before changing
      this.previousTab = this.activeTab;
    },

    // Métodos de salvamento
    salvarCamposAdicionais(isAutoSave = false) {
      this.loadingCampos = true;
      const camposParaSalvar = this.prepararCamposParaSalvar();

      this.$store
        .dispatch("atendimentoModule/editCamposAdicionais", camposParaSalvar)
        .then((response) => {
          this.handleSalvarResponse(response, isAutoSave);
        })
        .catch((error) => {
          this.MensagemError("Editar", "Falha ao editar!");
          this.loadingCampos = false;
        });
    },

    handleSalvarResponse(response, isAutoSave) {
      if (response.response?.data?.error) {
        this.MensagemError("Editar", "Falha ao editar!");
        this.loadingCampos = false;
        return;
      }

      if (isAutoSave) {
        this.showMessageSuccess("Salvar", "Salvo automaticamente com sucesso!");
        this.loadingCampos = false;
        this.resetInactivityTimer();
      } else {
        this.showMessageSuccess("Editar", "Editado com sucesso!");
        this.cancelar();
      }
    },

    handleEditResponse(response) {
      if (response.response?.data?.error) {
        this.MensagemError("Editar", "Falha ao editar!");
        return;
      }

      this.showMessageSuccess("Editar", "Editado com sucesso!");
      this.cancelar();
      this.loadCamposAdicionais();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
// Adicione os estilos do Quill
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.snow.css";
@import "~quill/dist/quill.bubble.css";
</style>
<style>
.teeth {
  width: 0;
  height: 0;
  border-left: 40px solid transparent;
  border-right: 40px solid transparent;
  border-bottom: 80px solid lightblue;
}
.disabled {
  pointer-events: none;
  opacity: 0.5; /* Você pode adicionar um efeito visual para indicar que o editor está desabilitado */
}

/* Estilos para o Quill Editor */
.ql-disabled {
  pointer-events: none;
  opacity: 0.5;
}

.ql-editor {
  min-height: 150px;
}

.quill-editor {
  margin-bottom: 1rem;
}
</style>
